import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface MetabaseEmbedResponse {
  iframe_url: string;
}

@Injectable({
  providedIn: 'root'
})
export class MetabaseService {
  private baseUrl = `${environment.apiUrl}/metabase`;
  private http$ = inject(HttpClient);

  /**
   * Get embedded Metabase dashboard URL
   * @param dashboardId The Metabase dashboard ID
   * @param expirationMinutes Token expiration in minutes (default: 10)
   * @returns Observable with iframe URL
   */
  getDashboardUrl(
    dashboardId: number,
    expirationMinutes: number = 10,
    darkMode?: boolean
  ): Observable<MetabaseEmbedResponse> {
    const params = new HttpParams()
      .set('dashboard_id', dashboardId.toString())
      .set('expiration_minutes', expirationMinutes.toString());

    const withDarkMode = darkMode === undefined
      ? params
      : params.set('darkmode', String(darkMode));

    return this.http$.get<MetabaseEmbedResponse>(`${this.baseUrl}/embed/dashboard`, { params: withDarkMode });
  }
}
